module.exports = __webpack_public_path__ + "static/media/18.0bb4e82b.svg";